import { useEffect } from 'react';
import L from 'leaflet';
import { wallGroups, allStats } from '../lib/moist';

// moisture walls as droplet pins on the map / floor plan (latest measurement; red = wet fields); tap opens the wall
export function useMoistPins(project, pick) {
  const key = JSON.stringify([(project.moist || []).map((m) => [m.id, m.pos, m.at, m.name, m.hi, allStats(m)?.max]), project.planOn, pick]);
  useEffect(() => {
    const map = window.__gissMapView?.()?.m;
    if (!map) return undefined;
    const g = L.layerGroup().addTo(map);
    wallGroups(project.moist).forEach((s) => {
      const m = s[s.length - 1];
      if (!m.pos || (project.planOn && m.pos.floor && m.pos.floor !== project.planOn)) return;
      const st = allStats(m), wet = st && st.max >= m.hi;
      const icon = L.divIcon({ className: 'mo-pin-wrap', html: `<span class="mo-pin ${wet ? 'wet' : ''}" data-testid="moist-pin-${m.id}"><svg viewBox="0 0 24 24" width="16" height="16" fill="#fff"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>${s.length > 1 ? `<b>${s.length}</b>` : ''}</span>`, iconSize: [30, 30], iconAnchor: [15, 28] });
      L.marker([m.pos.lat, m.pos.lon], { icon, zIndexOffset: 700 }).addTo(g).bindTooltip(m.name).on('click', () => window.dispatchEvent(new CustomEvent('giss-moist', { detail: m.id })));
    });
    return () => g.remove();
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
}
